// thien-viet-admin/src/api/pageSectionLinkV2.js
import Constant from "../lib/constant";
import axiosClient from "./axiosClient";

const API_BASE = (Constant.apiUrl || "").replace(/\/$/, "");

const url = `${API_BASE}/page-section-links`;

const pageSectionLinkApiV2 = {
  listByAdmin: (params) => {
    return axiosClient.get(url + "/admin", { params });
  },

  get: (params) => {
    return axiosClient.get(url + "/admin", { params });
  },

  batch: (body) => {
    return axiosClient.post(url + "/batch", body);
  },
};

export default pageSectionLinkApiV2;
